import { CheckCircle2, PartyPopper } from 'lucide-react';

type CampaignSuccessModalProps = {
  open: boolean;
  /** Navigate to campaigns list (primary CTA + backdrop / Escape). */
  onDone: () => void;
  campaignId?: string;
  variant?: 'create' | 'relaunch';
};

export function CampaignSuccessModal({
  open,
  onDone,
  variant = 'create',
}: CampaignSuccessModalProps) {
  if (!open) return null;

  const title =
    variant === 'relaunch'
      ? 'Campaign relaunch successful.'
      : 'Campaign created successfully.';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-[#0F1B2D]/45 backdrop-blur-[2px]"
        aria-label="Go to campaigns list"
        onClick={onDone}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="campaign-success-title"
        className="camp-fade-up relative z-10 w-full max-w-md overflow-hidden rounded-3xl bg-white text-center shadow-2xl"
      >
        <div
          className="h-1.5 w-full"
          style={{ background: 'var(--dash-gradient)' }}
        />
        <div className="px-8 py-8">
          <div className="relative mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[var(--dash-success-soft)]">
            <CheckCircle2 className="h-9 w-9 text-[var(--dash-success)]" />
            <PartyPopper className="absolute -top-1 -right-1 h-5 w-5 text-[var(--dash-accent)]" />
          </div>
          <h2
            id="campaign-success-title"
            className="m-0 text-2xl font-semibold tracking-tight text-[var(--dash-ink)]"
          >
            {/* You&apos;re live! */}
            {title}
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-[var(--dash-muted)]">
            Track Performance anytime from your
            campaigns list.
          </p>

          <div className="mt-6">
            <button
              type="button"
              onClick={onDone}
              className="dash-btn-gradient w-full rounded-xl px-4 py-3 text-sm font-semibold text-white"
            >
              View campaigns
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
